import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { sessionIsRecoverable } from '../lib/session';
import { sessionExpired } from '../store/slices/auth';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { selectIsAuthenticated } from '../store/selectors/auth';

export const ProtectedRoute = ({ children }) => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const location = useLocation();

  // A laptop can sleep for weeks. Re-checking on mount and on tab focus catches a dead
  // session before the user clicks anything, rather than on the first failed call.
  useEffect(() => {
    if (!isAuthenticated) return undefined;
    const check = () => {
      if (!sessionIsRecoverable()) dispatch(sessionExpired());
    };
    check();
    document.addEventListener('visibilitychange', check);
    return () => document.removeEventListener('visibilitychange', check);
  }, [isAuthenticated, dispatch]);

  return isAuthenticated ? children : <Navigate to="/login" state={{ from: location }} replace />;
};
